import React, { useEffect, useRef, useState } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { useAuth } from '../../context/AuthContext';
import { loginPathFor } from '../../context/signedInState';
import { CREATE_TINYCMS_READER_LINK } from '../../graphql';
import { PageLoader } from '../common/PageLoader';

/**
 * /reader-sign-in?site=<slug>&next=<path>: where a site's "Sign in" sends a reader
 * for a section kept for tinycms accounts. Signed out, it's the ordinary sign-in
 * first; then the server gives the address back on that site, and only that site
 * (an address in this page's own link is never trusted).
 */
export default function SiteSignIn() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const [params] = useSearchParams();
  const [error, setError] = useState('');
  const started = useRef(false);
  const [link] = useMutation(CREATE_TINYCMS_READER_LINK);

  useEffect(() => {
    if (!isAuthenticated || started.current) return;
    started.current = true;
    link({
      variables: {
        site: params.get('site') || '',
        next: params.get('next'),
        // The server honours this only outside production, for localhost.
        origin: params.get('origin'),
      },
    })
      .then(({ data }) => window.location.assign(data.createTinycmsReaderLink.url))
      .catch((err) => setError(err.message));
  }, [isAuthenticated, link, params]);

  if (isLoading) return <PageLoader variant="screen" />;
  if (!isAuthenticated) {
    const from = location.pathname + location.search;
    return <Navigate to={loginPathFor(from)} replace state={{ from }} />;
  }
  if (error) {
    return (
      <div className="ink-modal-copy" style={{ padding: 32 }} role="alert">
        That didn’t work: {error}
      </div>
    );
  }
  return <PageLoader variant="screen" />;
}
